import { ParametrosWSBase, DestinoConexion } from "../../ParametrosWSBase";
import { EncabezadoRespuestaInterna } from "../../EncabezadoRespuestaInterna";

export function ValidarPreRegistroRest_Parametros(datos: any) {
  var par: ParametrosWSBase = {
    nombreProceso: "ValidarPreRegistro",
    rutaEndPoint: "/EnterpriseServices/Sel/ValidarPreRegistroRest",
    sistemaOrigen: "SEL",
    AGREGAR_ENCABEZADO: true,
    DESTINO_SERVICIO: DestinoConexion.Proxy,
    parametros: { ...datos },
        cRC:null
  };

  return par;
}

export function builtDbValidarPreRegistroSelInput(CodigoPreRegistro: string) {
  var retorno: DbValidarPreRegistroSelInput = {
    CodigoPreRegistro: CodigoPreRegistro,
  };
  return retorno;
}

export function builtValidarPreRegistroRest_Entrada(
  l_DbValidarPreRegistroSelInput: DbValidarPreRegistroSelInput
) {
  var retorno: ValidarPreRegistroRest_Entrada = {
    DbValidarPreRegistroSelInput: l_DbValidarPreRegistroSelInput,
  };

  return retorno;
}

export function builtValidarPreRegistroInput(CodigoPreRegistro: string) {
  var retorno: ValidarPreRegistroRest_Entrada =
    builtValidarPreRegistroRest_Entrada(
      builtDbValidarPreRegistroSelInput(CodigoPreRegistro)
    );

  return retorno;
}

//
export interface ValidarPreRegistroRest_Entrada {
  DbValidarPreRegistroSelInput: DbValidarPreRegistroSelInput;
}

export interface DbValidarPreRegistroSelInput {
  CodigoPreRegistro: string;
}

export interface DbValidarPreRegistroSelOutputCollection {
  DbValidarPreRegistroSelOutput: DbValidarPreRegistroSelOutput[];
}

export interface DbValidarPreRegistroSelOutput {
  ESTATUS: string;
}

export interface ValidarPreRegistroRest_Salida {
  DbValidarPreRegistroSelOutputCollection: DbValidarPreRegistroSelOutputCollection;
}

export type ValidarPreRegistroRest_Respuesta = EncabezadoRespuestaInterna &
  ValidarPreRegistroRest_Salida;
